// extracted by mini-css-extract-plugin
module.exports = {"container":"b429494557--container--HJsgM","icon":"b429494557--icon--AlTwx"};